	if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this._abortController = new AbortController();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 300));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			// Cancel any in-flight request — AbortController ensures only the latest request completes
			this._abortController.abort();
			this._abortController = new AbortController();

			const body = JSON.stringify({
				id: item.dataset.id,
				quantity: newQty
			});

			// Two-fetch pattern: cart change (POST) then section rendering (GET)
			// Bundled Section Rendering via ?sections= requires a GET to a page route,
			// not a POST to /cart/change.js. The GET fetches both sections in one request.
			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body,
					signal: this._abortController.signal
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.textContent = response.description;
						} else {
							alert.textContent = response.message;
						}
					}

					// Fetch updated section HTML via GET (Bundled Section Rendering)
					return fetch('/cart?sections=helper-cart,ajax-cart-subtotal', {
						signal: this._abortController.signal
					});
				})
				.then(response => response.json())
				.then(response => {

					// Bundled Section Rendering — response contains section HTML as keys
					const helperCartHTML = response['helper-cart'];
					const subtotalHTML = response['ajax-cart-subtotal'];

					// Use DOM-based re-render for the helper-cart section (XSS hardening)
					// Shopify section rendering returns server-controlled HTML
					const cartItems = document.getElementById('AjaxCartForm');
					const temp = document.createElement('div');
					temp.innerHTML = helperCartHTML || '';
					const newCartForm = temp.querySelector('#AjaxCartForm');
					if ( newCartForm ) {
						cartItems.replaceChildren(...newCartForm.childNodes);
					}
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					}

					// Use DOM-based re-render for subtotal (XSS hardening)
					const subtotalContainer = document.getElementById('AjaxCartSubtotal');
					if ( subtotalContainer && subtotalHTML ) {
						const subTemp = document.createElement('div');
						subTemp.innerHTML = subtotalHTML;
						const newSubtotal = subTemp.querySelector('#AjaxCartSubtotal');
						if ( newSubtotal ) {
							subtotalContainer.replaceChildren(...newSubtotal.childNodes);
						}
					}
							
					const event = new Event('cart-updated');
					this.dispatchEvent(event);

				})
				.catch(e => {
					if ( e.name === 'AbortError' ) return; // Expected — ignore silently
					console.error(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
			// Debounced update to prevent rapid-fire cart API calls
			this._debouncedUpdate = debounce((item, qty) => {
				document.getElementById('AjaxCartForm').updateCartQty(item, qty);
			}, 300);
		}
		changeCartInput(){
			this._debouncedUpdate(
				this.closest('[data-js-cart-item]'),
				parseInt(this.querySelector('.qty').value)
			);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionDoc = new DOMParser().parseFromString(text, 'text/html');
			const cartFormHTML = sectionDoc.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalHTML = sectionDoc.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			const tempForm = document.createElement('div');
			tempForm.innerHTML = cartFormHTML;
			cartItems.replaceChildren(...tempForm.childNodes);
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			const subtotalTarget = document.getElementById('AjaxCartSubtotal');
			const tempSub = document.createElement('div');
			tempSub.innerHTML = cartSubtotalHTML;
			subtotalTarget.replaceChildren(...tempSub.childNodes);
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').replaceChildren();
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}